import { createApp } from 'vue'
import VueAxios from "vue-axios"
import VueApexCharts from "vue3-apexcharts"

import App from './App.vue'
import bootstrap from 'bootstrap'
import router from './router'
import store from './store'
import { initVeeValidate } from './plugins/vee-validate'
import axiosInstance from "./plugins/axios-plugin"
import { assetsFilter, dateFilters, durationFilters, numeralFilters } from "./global-filters";
import UserService from "./services/user-service";
import { asideIsOpen, closeAsideMenu } from "./services/aside-menu";
import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/vue-tel-input.css';

initVeeValidate()

const vueInstance = createApp(App)
vueInstance.use(bootstrap)
vueInstance.use(store)
vueInstance.use(router)
vueInstance.use(VueAxios, axiosInstance)
vueInstance.use(VueApexCharts)
vueInstance.config.globalProperties.$filters = { ...dateFilters, ...numeralFilters, ...durationFilters, ...assetsFilter }
vueInstance.config.globalProperties.$checkPermission = (entry) => {
  return UserService.hasPermission(entry)
}

vueInstance.use(VueTelInput)

window.addEventListener('resize', () => {
  const mobileBreakpoint = 768; // Example breakpoint for mobile
  const currentWidth = window.innerWidth;

  if (currentWidth >= mobileBreakpoint) {
    if (asideIsOpen()) {
      closeAsideMenu()
    }
  }
})


vueInstance.mount('#app')
